import * as S from './style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteRight } from '@fortawesome/free-solid-svg-icons';
import { Para, Head_3 } from '../Typography';
import Image from '../Image';
const ReviweCard = ({ name, company, position, image, quote }) => {
  return (
    <S.Wrapper>
      <S.Quote>
        <FontAwesomeIcon icon={faQuoteRight} />
      </S.Quote>
      <Para>{quote}</Para>
      <Image src={image} alt="testimonial" width="30%" margin="0" />
      <Head_3 marginBottom="1rem">{name}</Head_3>
      <Para>
        {position} at {company}
      </Para>
    </S.Wrapper>
  );
};

export default ReviweCard;
